/* ********************************************
 * import
 * ****************************************** */
import {gsap} from "gsap/gsap-core";


/* ********************************************
 * functions
 * ****************************************** */

// ===========================================
// scrollToSmooth
// スムーズなスクロールの処理
// ===========================================
export function scrollToSmooth(hash, duration = .6, event) {

  // console.log(duration);
  // console.log('event: ' + event);
  // console.log('hash: ' + hash);

  if (event !== undefined) {
    event.preventDefault(); // barabaでの非同期遷移後に、#付きリンクがクリックされると、スクロールイベントによって通常のスクロールが発生することを防ぐ
  }

  // 調整値の計算
  // const header = document.querySelector('#header');
  // const offset = header.offsetTop + header.clientHeight;  // スクロール位置の微調整  例）ヘッダーの高さ分下に下げる
  const header = document.querySelector('#header');
  const offset = header.clientHeight;  // スクロール位置の微調整  例）ヘッダーの高さ分下に下げる

  // 一番上へページ内スクロール
  if (hash === 'windowTop') {
    gsap.to(window, {duration: duration, scrollTo: {y: 0, offsetY: 0}});
    return;
  }

  // hash先にページ内スクロール
  let target;
  if (hash !== undefined && hash !== null && hash !== '') {
    target = document.querySelector(hash);

    if (target) {
      // ページ内スクロールの場合は、スムーズに移動（アニメーションを有効にする）
      // smoother.scrollTo(target, true, "top " + offset + "px");
      // ↑ スマホの慣性スクロールを切った状態だとスムーズスクロールにならないため ↓ を使う
      gsap.to(window, {duration: duration, scrollTo: {y: target, offsetY: offset}});
    } else {
      console.log('scrollToSmooth: scroll target not found.');
    }

  }
}
